export interface MCountryOptions {
    name: string;
    iso2: MCountryCodeISO2;
    dialCode: string;
    priority?: number;
    areaCodes?: string[];
}

export interface MCountry {
    iso: MCountryCodeISO2;
    prefix: string;
}

export enum MCountryCodeISO2 {
    Empty = '',
    Afghanistan = 'af',
    Alandislands = 'ax',
    Albania = 'al',
    Algeria = 'dz',
    Americansamoa = 'as',
    Andorra = 'ad',
    Angola = 'ao',
    Anguilla = 'ai',
    Antarctica = 'aq',
    Antiguaandbarbuda = 'ag',
    Argentina = 'ar',
    Armenia = 'am',
    Aruba = 'aw',
    Australia = 'au',
    Austria = 'at',
    Azerbaijan = 'az',
    Bahamas = 'bs',
    Bahrain = 'bh',
    Bangladesh = 'bd',
    Barbados = 'bb',
    Belarus = 'by',
    Belgium = 'be',
    Belize = 'bz',
    Benin = 'bj',
    Bermuda = 'bm',
    Bhutan = 'bt',
    Bolivia = 'bo',
    Bosniaandherzegovina = 'ba',
    Botswana = 'bw',
    Bouvetisland = 'bv',
    Brazil = 'br',
    Britishindianoceanterritory = 'io',
    Bruneidarussalam = 'bn',
    Bulgaria = 'bg',
    Burkinafaso = 'bf',
    Burundi = 'bi',
    Cambodia = 'kh',
    Cameroon = 'cm',
    Canada = 'ca',
    Capeverde = 'cv',
    Caymanislands = 'ky',
    Centralafricanrepublic = 'cf',
    Chad = 'td',
    Chile = 'cl',
    China = 'cn',
    Christmasisland = 'cx',
    Cocoskeelingislands = 'cc',
    Colombia = 'co',
    Comoros = 'km',
    Congo = 'cg',
    Congodemocraticrepublic = 'cd',
    Cookislands = 'ck',
    Costarica = 'cr',
    Cotedivoire = 'ci',
    Croatia = 'hr',
    Cuba = 'cu',
    Cyprus = 'cy',
    Czechrepublic = 'cz',
    Denmark = 'dk',
    Djibouti = 'dj',
    Dominica = 'dm',
    Dominicanrepublic = 'do',
    Ecuador = 'ec',
    Egypt = 'eg',
    Elsalvador = 'sv',
    Equatorialguinea = 'gq',
    Eritrea = 'er',
    Estonia = 'ee',
    Ethiopia = 'et',
    Falklandislands = 'fk',
    Faroeislands = 'fo',
    Fiji = 'fj',
    Finland = 'fi',
    France = 'fr',
    Frenchguiana = 'gf',
    Frenchpolynesia = 'pf',
    Frenchsouthernterritories = 'tf',
    Gabon = 'ga',
    Gambia = 'gm',
    Georgia = 'ge',
    Germany = 'de',
    Ghana = 'gh',
    Gibraltar = 'gi',
    Greece = 'gr',
    Greenland = 'gl',
    Grenada = 'gd',
    Guadeloupe = 'gp',
    Guam = 'gu',
    Guatemala = 'gt',
    Guernsey = 'gg',
    Guinea = 'gn',
    Guineabissau = 'gw',
    Guyana = 'gy',
    Haiti = 'ht',
    Heardislandmcdonaldislands = 'hm',
    Holyseevaticancitystate = 'va',
    Honduras = 'hn',
    Hongkong = 'hk',
    Hungary = 'hu',
    Iceland = 'is',
    India = 'in',
    Indonesia = 'id',
    Iran = 'ir',
    Iraq = 'iq',
    Ireland = 'ie',
    Isleofman = 'im',
    Israel = 'il',
    Italy = 'it',
    Jamaica = 'jm',
    Japan = 'jp',
    Jersey = 'je',
    Jordan = 'jo',
    Kazakhstan = 'kz',
    Kenya = 'ke',
    Kiribati = 'ki',
    Korea = 'kr',
    Kuwait = 'kw',
    Kyrgyzstan = 'kg',
    Laopeoplesdemocraticrepublic = 'la',
    Latvia = 'lv',
    Lebanon = 'lb',
    Lesotho = 'ls',
    Liberia = 'lr',
    Libyanarabjamahiriya = 'ly',
    Liechtenstein = 'li',
    Lithuania = 'lt',
    Luxembourg = 'lu',
    Macao = 'mo',
    Macedonia = 'mk',
    Madagascar = 'mg',
    Malawi = 'mw',
    Malaysia = 'my',
    Maldives = 'mv',
    Mali = 'ml',
    Malta = 'mt',
    Marshallislands = 'mh',
    Martinique = 'mq',
    Mauritania = 'mr',
    Mauritius = 'mu',
    Mayotte = 'yt',
    Mexico = 'mx',
    Micronesia = 'fm',
    Moldova = 'md',
    Monaco = 'mc',
    Mongolia = 'mn',
    Montenegro = 'me',
    Montserrat = 'ms',
    Morocco = 'ma',
    Mozambique = 'mz',
    Myanmar = 'mm',
    Namibia = 'na',
    Nauru = 'nr',
    Nepal = 'np',
    Netherlands = 'nl',
    Netherlandsantilles = 'an',
    Newcaledonia = 'nc',
    Newzealand = 'nz',
    Nicaragua = 'ni',
    Niger = 'ne',
    Nigeria = 'ng',
    Niue = 'nu',
    Norfolkisland = 'nf',
    Northernmarianaislands = 'mp',
    Norway = 'no',
    Oman = 'om',
    Pakistan = 'pk',
    Palau = 'pw',
    Palestinianterritory = 'ps',
    Panama = 'pa',
    Papuanewguinea = 'pg',
    Paraguay = 'py',
    Peru = 'pe',
    Philippines = 'ph',
    Pitcairn = 'pn',
    Poland = 'pl',
    Portugal = 'pt',
    Puertorico = 'pr',
    Qatar = 'qa',
    Reunion = 're',
    Romania = 'ro',
    Russianfederation = 'ru',
    Rwanda = 'rw',
    Saintbarthelemy = 'bl',
    Sainthelena = 'sh',
    Saintkittsandnevis = 'kn',
    Saintlucia = 'lc',
    Saintmartin = 'mf',
    Saintpierreandmiquelon = 'pm',
    Saintvincentandgrenadines = 'vc',
    Samoa = 'ws',
    Sanmarino = 'sm',
    Saotomeandprincipe = 'st',
    Saudiarabia = 'sa',
    Senegal = 'sn',
    Serbia = 'rs',
    Seychelles = 'sc',
    Sierraleone = 'sl',
    Singapore = 'sg',
    Slovakia = 'sk',
    Slovenia = 'si',
    Solomonislands = 'sb',
    Somalia = 'so',
    Southafrica = 'za',
    Southgeorgiaandsandwichisl = 'gs',
    Spain = 'es',
    Srilanka = 'lk',
    Sudan = 'sd',
    Suriname = 'sr',
    Svalbardandjanmayen = 'sj',
    Swaziland = 'sz',
    Sweden = 'se',
    Switzerland = 'ch',
    Syrianarabrepublic = 'sy',
    Taiwan = 'tw',
    Tajikistan = 'tj',
    Tanzania = 'tz',
    Thailand = 'th',
    Timorleste = 'tl',
    Togo = 'tg',
    Tokelau = 'tk',
    Tonga = 'to',
    Trinidadandtobago = 'tt',
    Tunisia = 'tn',
    Turkey = 'tr',
    Turkmenistan = 'tm',
    Turksandcaicosislands = 'tc',
    Tuvalu = 'tv',
    Uganda = 'ug',
    Ukraine = 'ua',
    Unitedarabemirates = 'ae',
    Unitedkingdom = 'gb',
    Unitedstates = 'us',
    Unitedstatesoutlyingislands = 'um',
    Uruguay = 'uy',
    Uzbekistan = 'uz',
    Vanuatu = 'vu',
    Venezuela = 've',
    Vietnam = 'vn',
    Virginislandsbritish = 'vg',
    Virginislandsus = 'vi',
    Wallisandfutuna = 'wf',
    Westernsahara = 'eh',
    Yemen = 'ye',
    Zambia = 'zm',
    Zimbabw = 'zw'
}
